import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-features-not-available-box',
  templateUrl: './features-not-available-box.component.html',
  styleUrls: ['./features-not-available-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturesNotAvailableBoxComponent {}
